<template>
	<div class="waterfertilizer">
		 <dv-scroll-board :config="config" style="width:100%;height:275px" @mouseover="handleMouseOver" @mouseout="handleMouseOut" />
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted,
		reactive
	} from 'vue';
	import {
		GetWateringFertilizationTables
	} from '@/api/api.js';
	import mitt from '@/utils/bus.js';
	import {
	  CirclePlus
	} from '@element-plus/icons-vue'
	const config = ref({
		header: ['id','工作员','名称','方式', '操作时间'],
		data: [],
		columnWidth: [40,75,75,60,200],
		align: ['center'],
		headerBGC:'#11a882',
		//奇数
		oddRowBGC:'#024437',
		//偶数
		evenRowBGC:"",
		waitTime:5000,
	});
	GetWateringFertilizationTables('1').then(res => {
		res.data.forEach((item) => {
			config.value.data.push([item.id,item.operator, item.fertilizerName,
				item.useFertilizer, item.createDate,''])
		})
	}).catch(err => {
		console.log(err)
	})
	mitt.on('InsertWateringFertilizationTablesDetail',()=>{
		GetWateringFertilizationTables('1').then(res => {
			res.data.forEach((item) => {
				config.value.data.push([item.id,item.operator, item.fertilizerName,
					item.useFertilizer, item.createDate,''])
			})
		}).catch(err => {
			console.log(err)
		})
	})
</script>

<style lang="scss">
	.waterfertilizer{
		
		width: 98%;
		margin: 0 auto;
		height: 275;
	}
</style>